<template>
  <component
    :is="ctype"
    :value="detail"
    :choices="choices"
    :label="label"
    :detail="detail"
    @change="valueChanged"
    :readonly="readonly"
    :fieldlabel="fieldlabel"
    :radios="radios"
    :clearable="clearable"
    :suffix="suffix"
    :required="required"
    :maxlength="maxlength"
    :rules="rules"
    :hidedetails="hidedetails"
  ></component>
</template>

<script>
import StringInput from "./StringInput.vue";
import IntInput from "./IntegerInput.vue";
import FloatInput from "./FloatInput.vue";
import FixedCombo from "./FixedCombo.vue";
import RadioGroup from "./RadioGroup.vue";
import ObjectCombo from "./ObjectCombo.vue";
import CheckboxInput from "./CheckboxInput.vue";

export default {
  props: [
    "detail",
    "readonly",
    "type",
    "fieldlabel",
    "choices",
    "label",
    "radios",
    "clearable",
    "suffix",
    "required",
    "maxlength",
    "rules",
    "hidedetails"
  ],
  components: {
    StringInput,
    IntInput,
    FloatInput
  },
  computed: {
    ctype() {
      //      this.$log.debug("detail:", this.detail);
      //      this.$log.debug("ctype:" + this.wbs.source + "+" + this.wbs.datatype);
      switch (this.type) {
        case "STRING":
          return StringInput;
        case "INTEGER":
          return IntInput;
        case "FLOAT":
          return FloatInput;
        case "LIST":
          return FixedCombo;
        case "RADIO":
          return RadioGroup;
        case "SELECT":
          return ObjectCombo;
        case "CHECKBOX":
          return CheckboxInput;
      }
      return undefined;
    }
  },
  methods: {
    valueChanged(newValue) {
      this.$log.debug("ValueEditor::valueChanged(" + newValue + ")");
      this.$emit("change", newValue);
    }
  }
};
</script>
